import React from 'react';

const extensionIconMapping: Record<string, string> = {
  pdf: 'icon-pdf',
  doc: 'icon-doc',
  docx: 'icon-doc',
  xls: 'icon-xls',
  xlsx: 'icon-xls',
  ppt: 'icon-ppt',
  pptx: 'icon-pptx',
  mp4: 'icon-mp4',
  youtube: 'icon-youtube',
  vimeo: 'icon-vimeo',
  json: 'icon-json',
  txt: 'icon-txt',
  other: 'icon-other',
  html: 'icon-html',
  xml: 'icon-xml',
  md: 'icon-md',
};

interface FileIconProps {
  fileName?: string;
  extension?: string;
  size?: number;
  className?: string;
}

/**
 * Componente para exibir ícones baseados na extensão do arquivo
 * @param fileName - Nome completo do arquivo (opcional)
 * @param extension - Extensão do arquivo (opcional)
 * @param size - Tamanho do ícone em pixels
 * @param className - Classes CSS adicionais
 */
export const FileIcon: React.FC<FileIconProps> = ({
  fileName,
  extension,
  size = 24,
  className = '',
}) => {
  const getExtension = (): string => {
    if (extension) {
      return extension.toLowerCase().replace('.', '');
    }
    
    if (fileName) {
      const parts = fileName.split('.');
      if (parts.length > 1) {
        return parts[parts.length - 1].toLowerCase();
      }
    }
    
    return 'other';
  };

  const getIconName = (ext: string): string => {
    return extensionIconMapping[ext] || 'icon-other';
  };

  const ext = getExtension();
  const iconName = getIconName(ext);
  const iconPath = `/icons/extensions/small/${iconName}.svg`;

  return (
    <img 
      src={iconPath} 
      alt={`${ext} file`} 
      width={size} 
      height={size} 
      className={className} 
    />
  );
};

export default FileIcon;

